export class ProductFlags {
  liveSessions: boolean = true;
  shoppableVideos: boolean = true;
  polls: boolean = true;
  timelines: boolean = true;
  sceneBuilder: boolean = false;
}

const defaultProductFlags = {
  liveSessions: true,
  shoppableVideos: true,
  polls: true,
  timelines: true,
  sceneBuilder: false,
};

export class DbIntegrationModel {
  id: string;
  integrationClass: string = 'BaseGeneric';
  apiUrl: string = '';
  websiteUrl: string = '';
  apiToken: string = '';
  storeId: string;
  cartPath: string = 'checkout/cart';
  productUniqueIdFieldName: string = 'id';
  productVariantUniqueIdFieldName: string = 'sku';
  productCatalogUrl: string = '';
  productSyncFrequency: string = '30 2 * * *';
  productIds: string[] = [];
  analyticsUrl: string = '';
  credentials: {
    username: string;
    password: string;
  };
  EmbeddingFontFamily: string;
  extraProductIds?: string;
  productFlags: ProductFlags = defaultProductFlags;
  headerElements: string = '';
  customerStoreId: string = '';

  static fromDb(data: Partial<DbIntegrationModel>): DbIntegrationModel {
    if (!data) return data;
    const instance = new DbIntegrationModel();

    Object.assign(instance, data);

    if (!data.productFlags) {
      instance.productFlags = defaultProductFlags;
    } else {
      instance.productFlags = Object.assign(new ProductFlags(), data.productFlags);
    }

    return instance;
  }
}
